import { Component, OnInit } from '@angular/core';
import { EnginesService } from '../../services/engines.service';
import { UsersService } from '../../services/users.service';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/mergeMap';
import { ToasterService } from 'angular2-toaster';
import { Response } from "@angular/http";

declare function confirm(message?: string);

@Component({
    selector: 'app-users',
    templateUrl: './engines.component.html'
})

export class EnginesComponent implements OnInit {
    public engines: Array<RV.Engine> = [];
    public users: Array<any> = [];

    constructor(
        private enginesService: EnginesService,
        private toasterService: ToasterService,
        private usersService: UsersService
    ) {
    }

    ngOnInit() {
        Observable.forkJoin(
            this.enginesService.getAll(),
            this.usersService.getAll()
        ).subscribe(([engines, users]) => {
            this.engines = engines;
            this.users = users;
        });
    }

    toggleEditEngine(engine) {
        engine.editing = !engine.editing;
    }

    restartEngine(engine: RV.Engine) {
        if (confirm("Are you sure you want to restart this engine?")) {
            this.enginesService
                .restart(engine)
                .subscribe((resp: Response) => {
                    const status: RV.EngineStatus = resp.json();

                    engine.status = status;
                    this.toasterService.pop('success', 'Success', 'Engine is restarting');
                });
        }
    }

    saveEngine(engine) {
        delete engine.editing;

        const newUserId = engine.user_id;

        this.enginesService.update(engine.id, newUserId).subscribe(() => {
            engine.user = this.users.filter(thisUser => thisUser.id === newUserId)[0];
            engine.user_id = engine.user ? engine.user.id : null; // Update this engine object back to original.

            this.toasterService.pop('success', 'Success', 'Engine updated');
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/engines/engines.component.ts